import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Form } from 'reactstrap';
import { CardBody } from 'reactstrap';
import BasicsFieldset from './fieldsets/BasicsFieldset';
import LocationFieldset from './fieldsets/LocationFieldset';
import DateTimeFieldset from './fieldsets/DateTimeFieldset';
import { stepValidationFactory } from 'actions/submissionFormActions';
import scrollToFirstError from 'lib/utils/scrollToFirstError';
import TitleHeader from '../TitleHeader';

class BasicsForm extends Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    timeZones: PropTypes.array.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    formErrors: PropTypes.object,
    isLoading: PropTypes.bool,
    online: PropTypes.bool,
    config: PropTypes.object,
    change: PropTypes.func.isRequired,
    availableCountries: PropTypes.object.isRequired,
    onClearAddress: PropTypes.func.isRequired,
    onVenueSelect: PropTypes.func.isRequired,
    onChangeCountry: PropTypes.func.isRequired,
    onChangeZip: PropTypes.func.isRequired,
    currentUser: ImmutablePropTypes.map,
    pricingTiers: ImmutablePropTypes.map.isRequired,
  }

  clearAddress = () => {
    this.props.change('venue', {});
    this.props.onClearAddress();
  }

  render() {
    const {
      formErrors, isLoading, categories, timeZones, config, pricingTiers, onChangeZip, online,
      handleSubmit, availableCountries, onVenueSelect, currentUser, onChangeCountry } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <fieldset disabled={isLoading}>
          <div className="card-header">
            <h4>Event Title</h4>
          </div>
          <CardBody>
            <BasicsFieldset
              formErrors={formErrors}
              config={config}
              categories={categories}
              currentUser={currentUser}
              pricingTiers={pricingTiers}
            />
          </CardBody>
          <TitleHeader title="Event Location" infoUrl="https://support.evvnt.com/hc/en-us/articles/360020723054-Basics-Adding-your-event-venue" containerClass="mt-0" required/>
          <CardBody>
            <LocationFieldset
              formErrors={formErrors}
              onClearAddress={this.clearAddress}
              availableCountries={availableCountries}
              onVenueSelect={onVenueSelect}
              onChangeCountry={onChangeCountry}
              onChangeZip={onChangeZip}
              online={online}
            />
          </CardBody>
          <div className="card-header">
            <h4>When</h4>
          </div>
          <CardBody>
            <DateTimeFieldset
              formErrors={formErrors}
              categories={categories}
              timeZones={timeZones}
            />
          </CardBody>
        </fieldset>
        <button type="submit" className="d-none"/>
      </Form>
    );
  }
}

export default reduxForm({
  form: 'eventSubmission',
  destroyOnUnmount: false,
  asyncValidate: stepValidationFactory('basics'),
  onSubmitFail: scrollToFirstError,
  persistentSubmitErrors: true,
})(BasicsForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/BasicsForm.jsx